import React from 'react';
import { extensions } from '@yola/ws-sdk';
import common from '../constants/common';
import canBeMovedBackward from '../helpers/can-be-moved-backward';
import canBeMovedForward from '../helpers/can-be-moved-forward';
import MoveBackward from '../components/move-backward';

const { MOVE_BACKWARD } = common;

const layerBackwardControl = {
  id: MOVE_BACKWARD,
  trigger: <MoveBackward />,
  matches(liveElement) {
    const settings = extensions.accessors.getExtensionSettings(common.slug);
    const isMatched = liveElement.matches(settings.elementToReorderSelector);

    if (!isMatched) return false;

    return canBeMovedBackward(liveElement) || canBeMovedForward(liveElement);
  },
  priority: 39,
};

export default layerBackwardControl;
